import "./LoadingScreen.scss";

import * as React from "react";
import {ContentDataHelper} from "../../../app/helper/ContentDataHelper";
import {AssetsLoadManager} from "../../../app/controller/AssetLoader/AssetsLoadManager";
import {AssetLoader} from "../../../app/controller/AssetLoader/AssetLoader";
import {URLHelper} from "../../../app/helper/URLHelper";
import {TimelineMax} from "gsap/TimelineMax";
import {TweenMax} from "gsap/TweenMax";
import {Power1} from "gsap/EasePack";
import {AppConfig} from "../../../app/models/AppConfig";


export interface LoadingScreenProps {
    locale: string;
    appConfig: AppConfig;

    registerURLs?: (urls: string[]) => void;

    setOverviewData: (data: any[]) => void;

    applicationStart: (content: any) => void;
    applicationReady: () => void;

    openNextScreen: () => void;
    removeCurrentScreen: () => void;
}

export class LoadingScreen extends React.Component<LoadingScreenProps, {}> {
    state = {
        progress: 0,
        filesLoaded: 0,
        filesTotal: 0,
    };

    constructor(props: any, context?: any) {
        super(props, context);
    }

    componentDidMount(): void {
        setTimeout(() => {
            this.loadContentXML();
        }, 1000);

        TweenMax.fromTo('.LoadingScreen .first-line', 0.3, {autoAlpha: 0}, {
            autoAlpha: 1,
            ease: Power1.easeIn,
            delay: 0
        });
        TweenMax.fromTo('.LoadingScreen .second-line', 0.25, {autoAlpha: 0}, {
            autoAlpha: 1,
            ease: Power1.easeIn,
            delay: .1
        });
    }

    loadContentXML = (): void => {
        AssetLoader.loadFile(
            this.props.appConfig.contentPath + this.props.appConfig.contentXML,
            (fileData: any, id: string) => {
                this.readContent(fileData);
            },
            (id: string, errorMessage: any) => {
                this.setState({
                    hasLoadError: true,
                    loadErrorMessage: "An Error occurred:\nWhile loading the content xml:\n" + errorMessage,
                });

                console.log("error", id, errorMessage);
            },
            (progress: number) => {
                //console.log("progress", progress);
            }
        );
    };

    readContent = (fileData: any): void => {
        fileData = ContentDataHelper.injectGlobalElements(fileData);
        const toBePreloaded: string[] = ContentDataHelper.getSrcsToBePreloaded(fileData);
        URLHelper.validURLs = ContentDataHelper.getListOfURLs(fileData);

        this.props.applicationStart(fileData);
        this.props.setOverviewData(ContentDataHelper.getDataSlideByID('overview', fileData));

        const assetLoadManager: AssetsLoadManager = new AssetsLoadManager([]);
        toBePreloaded.map((srcs: string, i: number) => {
            assetLoadManager.add({url: this.props.appConfig.contentPath + srcs});
        });

        assetLoadManager.on(AssetsLoadManager.EVENT_PROGRESS, (progress: number) => {
            this.setState({
                progress: progress,
                filesLoaded: assetLoadManager.numLoaded,
                filesTotal: assetLoadManager.numTotal,
            });
        });

        assetLoadManager.on(AssetsLoadManager.EVENT_COMPLETE, (evt: any) => {
            this.animateScreenOut();
        });

        assetLoadManager.start();
    };

    animateScreenOut = () => {
        this.props.applicationReady();

        const tl: TimelineMax = new TimelineMax();

        if (URLHelper.isLocalDev) {
            //tl.timeScale(10);
        }

        TweenMax.set('.LoadingScreen .logo', {autoAlpha: 0, y: '10px', scale: .5});
        TweenMax.set('.LoadingScreen .sub-logo', {autoAlpha: 0, y: '-3px', scale: .5});

        tl.to('.LoadingScreen .first-line', 0.3, {autoAlpha: 0, ease: Power1.easeOut, delay: .4});
        tl.to('.LoadingScreen .second-line', 0.25, {
            autoAlpha: 0, ease: Power1.easeOut, delay: -.2,
            onComplete: this.props.openNextScreen
        });
        tl.call(this.props.removeCurrentScreen);

        tl.play();
    };

    render() {
        const percent: number = Math.round(this.state.progress * 100);
        let percentString: string = "" + (!isNaN(percent) ? percent : 0);
        let filesLoaded: string = this.state.filesLoaded.toString();
        let filesTotal: string = this.state.filesTotal.toString();

        while (percentString.length < 3) {
            percentString = "0" + percentString;
        }

        while (filesLoaded.length < filesTotal.length) {
            filesLoaded = "0" + filesLoaded;
        }

        return <div className='LoadingScreen'>
            <div className={'vh-center'}>
                <p className={'first-line'}>
                    <span className={'percent'}>{percentString}</span><span className={'unit'}>%</span>
                </p>
                <p className={'second-line'}>
                    <span className={'loaded'}>{filesLoaded}</span> <span className={'separator'}>/</span> <span
                    className={'total'}>{filesTotal}</span>
                    <span className={'unit'}>&nbsp;&nbsp;&nbsp;</span>
                </p>
            </div>
        </div>
    }
}
